import { AppBar, Box, Button, Stack, useTheme, useMediaQuery } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { AppDispatch } from '../../../store'
import { AppActions, AppSelector } from '../../../store/app'
import { PersonForwardOutlined, SippLogo } from '../../icons'
import { MobileMenu } from './MobileMenu'
import { MobileMenuController } from './MobileMenuController'
import { ProfileNavigationTabs } from './ProfileNavigationTabs'

export const ProfileHeader = () => {
  const location = useLocation()
  const ref = useRef(null)
  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down('md'))
  const [menuOpen, setMenuOpen] = useState(false)
  const [refAvailable, setRefAvailable] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const isSharedView = useSelector(AppSelector.getIsSharedView) || !!localStorage.getItem('shareToken')
  const handleMenuClick = () => {
    setMenuOpen(!menuOpen)
  }
  const handleNavigationChange = (e, value) => {
    handleMenuClick()
    navigate(value)
  }
  const handleShareClick = () => {
    dispatch(AppActions.toggleShareResultsModal())
  }

  useEffect(() => {
    if (ref.current) {
      setRefAvailable(true)
    }
  }, [])
  if (!location.pathname.startsWith('/profile/')) return null

  return (
    <>
      <AppBar
        elevation={0}
        position="sticky"
        ref={ref}
        sx={{
          display: 'relative',
          background: { xs: 'rgba(255, 255, 255, 0.2)', md: 'rgba(255, 255, 255, 1)' },
          p: 1,
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
          <SippLogo sx={{ fontSize: { xs: '2.5rem', md: '3rem' }, ml: { xs: 0, md: 1 } }} />
          <Box sx={{ flexGrow: 1 }} />
          {!isSharedView && <Button
            variant="outlined"
            size="small"
            startIcon={<PersonForwardOutlined />}
            onClick={handleShareClick}
            sx={{ mr: 1 }}
          >
            Share My Results
          </Button>}
          {refAvailable && mobile && (
            <MobileMenu anchorEl={ref.current} open={menuOpen} onClose={handleMenuClick}>
              <ProfileNavigationTabs mobile onChange={handleNavigationChange}/>
            </MobileMenu>
          )}
          {mobile && <MobileMenuController onClick={handleMenuClick}/>}
        </Stack>
      </AppBar>
      {!mobile && (
        <Box sx={{ display: 'flex', justifyContent: 'center', bgcolor: 'rgba(255, 255, 255, 1)' }}>
          <ProfileNavigationTabs onChange={handleNavigationChange} />
        </Box>
      )}
    </>
  )
}
